import gql from 'graphql-tag'
import client from '../../stores/apollo'
import { WorkplaceGroupFragment } from '@api/fragments'
import { IWorkplaceGroup } from '@api/types'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  deleteWorkplaceGroup: {
    workplaceGroup: IWorkplaceGroup
  }
}

const mutation = gql`
  mutation DeleteWorkplaceGroupMutation($input: DeleteWorkplaceGroupInput!) {
    deleteWorkplaceGroup(input: $input) {
      workplaceGroup {
        ...WorkplaceGroupFragment
      }
    }
  }
  ${WorkplaceGroupFragment}
`

const mutateHandler = handleFetchResult<IPayload, IWorkplaceGroup>({
  handler: (data) => data.deleteWorkplaceGroup.workplaceGroup,
  name: 'Workplace Group',
})

export default function deleteWorkplaceGroup(workplaceGroupId: string): Promise<IWorkplaceGroup> {
  return client.gql
    .mutate({
      mutation,
      variables: { input: { id: workplaceGroupId } },
    })
    .then(mutateHandler)
}
